export enum AddressHoldersEnum {
  Beneficiary = 'beneficiary',
  Producer = 'producer',
  ProducerGroup = 'producerGroup',
  Insured = 'insured',
  Contact = 'contact',
}
